module.exports = __webpack_public_path__ + "static/Abbotsford4_dark-f31ea2dceb29168afbd2197b6ad33e5e.jpg";